<script setup lang="ts">
import type { SectionPushRecord, CtaRecord } from '~/types/datocms'

const props = defineProps<{
  data: SectionPushRecord
  moduleIndex: number
}>()

const { level, isSemantic } = useSectionRules(props.moduleIndex, !!props.data.title)

const handleExternalLink = (button: CtaRecord) => {
  if (!button.recordLink && !button.externalLink) {
    console.warn(`No link provided for "${button.title}" call to action`, button)
    return undefined
  } else if (button.externalLink?.startsWith('#')) {
    return {
      path: useLocalePathByType(
        button.recordLink?._modelApiKey ?? '',
        button.recordLink?.slug as string
      ),
      hash: button.externalLink
    }
  } else if (button.externalLink?.startsWith('?')) {
    return (
      useLocalePathByType(
        button.recordLink?._modelApiKey ?? '',
        button.recordLink?.slug as string
      ) + button.externalLink
    )
  } else if (button.externalLink?.startsWith('http')) {
    return button.externalLink
  } else if (button.recordLink) {
    return useLocalePathByType(button.recordLink?._modelApiKey, button.recordLink?.slug as string)
  }
}
</script>

<template>
  <section class="bg-black py-4 text-grey-light lg:py-12">
    <div class="container grid-default gap-y-6">
      <div class="col-span-full flex flex-col gap-6 lg:col-span-6">
        <Heading
          v-if="data.title"
          class="text-2xl uppercase"
          :level="level"
          :size="undefined"
          :is-semantic="isSemantic"
          >{{ data.title }}</Heading
        >
        <div v-if="data.html" class="text-base" v-html="data.html" />
      </div>
      <div v-if="data.links?.length" class="col-span-full flex flex-col lg:col-span-6 lg:items-end">
        <HyperLink
          v-for="(link, idx) in data.links"
          :key="idx"
          class="w-fit py-1.5 transition-colors duration-300 hover:text-yellow lg:py-1"
          :to="handleExternalLink(link)"
          :target="link.externalLink?.startsWith('http') ? '_blank' : undefined"
          :content="link.title ?? ''"
        />
      </div>
    </div>
  </section>
</template>
